import React from 'react';
import BrandBackgroundLogo from 'resources/images/logo-background.svg';
import { ReactComponent as LogoSymbol } from 'resources/images/symbol.svg';
import AppStoreBadge from 'resources/images/mobile-app-store-badge.svg';
import GooglePlayStoreBadge from 'resources/images/google-play-store-badge.svg';
import { externalLinks } from 'app/api.config';
import { Box, Button, Container, Flex, Link, Text } from '@chakra-ui/react';

export const UnsupportedMobileComponent: React.FC = () => (
  <Box
    position="fixed"
    zIndex={9999}
    left={0}
    right={0}
    top={0}
    bottom={0}
    background="white"
  >
    <Box
      height={381}
      bg="surface1"
      backgroundImage={`url(${BrandBackgroundLogo})`}
    >
      <Container maxW={678} px={6}>
        <Flex py={4} justifyContent="space-between" alignItems="center">
          <LogoSymbol
            role="img"
            height={32}
            width={32}
            data-testid="header logo"
            fill="white"
          />
          <Text
            as={Link}
            color="white"
            fontWeight={500}
            lineHeight="large"
            href={externalLinks.sessionLanding}
          >
            Visit Sessionstudio.com
          </Text>
        </Flex>
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          margin="auto"
          maxWidth={433}
          height={317}
        >
          <Text
            fontSize="xl"
            lineHeight="large"
            color="white"
            textAlign="center"
            mb={2}
          >
            Session Studio does not support this screen size.
          </Text>
          <Text
            fontSize="md"
            lineHeight="large"
            color="white"
            textAlign="center"
          >
            Please download Session Studio for iOS, Android or use the Desktop
            or Web applications.
          </Text>
          <Flex width={265} justifyContent="space-between" pt={6}>
            <Button
              width={120}
              height={10}
              backgroundImage={`url(${AppStoreBadge})`}
              as={Link}
              href={externalLinks.mobileApp.IOS_APP_LINK}
            />
            <Button
              width={135}
              height={10}
              backgroundImage={`url(${GooglePlayStoreBadge})`}
              as={Link}
              href={externalLinks.mobileApp.ANDROID_APP_LINK}
            />
          </Flex>
        </Flex>
      </Container>
    </Box>
  </Box>
);
